import { render, staticRenderFns } from "./showProductsComponent.vue?vue&type=template&id=dc6cdc94"
import script from "./showProductsComponent.vue?vue&type=script&lang=js"
export * from "./showProductsComponent.vue?vue&type=script&lang=js"
import style0 from "./showProductsComponent.vue?vue&type=style&index=0&id=dc6cdc94&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc6cdc94')) {
      api.createRecord('dc6cdc94', component.options)
    } else {
      api.reload('dc6cdc94', component.options)
    }
    module.hot.accept("./showProductsComponent.vue?vue&type=template&id=dc6cdc94", function () {
      api.rerender('dc6cdc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/showProductsComponent.vue"
export default component.exports